import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=f10fc4d4&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10fc4d4",
  null
  
)

export default component.exports